import React, { useState } from 'react';

function PrivacyPolicy() {
  const [activeSection, setActiveSection] = useState('user');

  return (
    <div className="min-vh-100 bg-white py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <h1 className="display-4 fw-bold" style={{ color: '#000000' }}>Privacy Policy</h1>
            </div>

            {/* Toggle Buttons */}
            <div className="text-center mb-4">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${activeSection === 'user' ? 'btn-dark text-white' : 'btn-outline-dark'}`}
                  onClick={() => setActiveSection('user')}
                >
                  User Privacy Policy
                </button>
                <button
                  type="button"
                  className={`btn ${activeSection === 'driver' ? 'btn-dark text-white' : 'btn-outline-dark'}`}
                  onClick={() => setActiveSection('driver')}
                >
                  Driver Privacy Policy
                </button>
              </div>
            </div>

            {/* User Privacy */}
            {activeSection === 'user' && (
              <div className="privacy-section">
                <h2 className="mb-4 border-bottom pb-2" style={{ color: '#000000' }}>User Privacy Policy</h2>
                
                <div className="mb-4">
                  <h5 className="fw-bold text-dark">1. What personal information do we collect from users?</h5>
                  <p className="text-muted">We collect personal information including your name, email address, phone number, and payment details to create and manage your account.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">2. When is location data collected?</h5>
                  <p className="text-muted">Location data is collected only during active ride bookings to provide you with accurate pickup, navigation, and service provision.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">3. How is my ride history used?</h5>
                  <p className="text-muted">Your ride history and preferences are stored to improve your user experience and provide personalized service recommendations.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">4. How is my payment information secured?</h5>
                  <p className="text-muted">Payment information is encrypted and stored securely with PCI compliance standards to ensure the highest level of security.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">5. Can I access or delete my personal data?</h5>
                  <p className="text-muted">Users can access, modify, or request deletion of their personal data through account settings or by contacting our support team.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">6. Do you sell user data to third parties?</h5>
                  <p className="text-muted">We do not sell user data to third parties for marketing purposes. Data is only shared with service providers essential for our operations.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">7. How can I manage communication preferences?</h5>
                  <p className="text-muted">Communication preferences can be managed in your notification settings within the app, allowing you to control what messages you receive.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">8. How long is my data retained?</h5>
                  <p className="text-muted">Data is retained for legal and operational requirements as necessary, and is deleted when no longer required for these purposes.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">9. Will I be notified of policy changes?</h5>
                  <p className="text-muted">Users will be notified of any significant changes to our privacy policy through app notifications and email communications.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">10. How can I contact about data deletion?</h5>
                  <p className="text-muted">For data deletion requests or privacy concerns, contact our privacy team at privacy@dailo.com for prompt assistance.</p>
                </div>
              </div>
            )}

            {/* Driver Privacy */}
            {activeSection === 'driver' && (
              <div className="privacy-section">
                <h2 className="mb-4 border-bottom pb-2" style={{ color: '#000000' }}>Driver Privacy Policy</h2>
                
                <div className="mb-4">
                  <h5 className="fw-bold text-dark">1. What driver information is collected?</h5>
                  <p className="text-muted">We collect driver information including license details, vehicle information, and background check results to ensure safety and compliance.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">2. When is driver location tracked?</h5>
                  <p className="text-muted">Location data is tracked during active driving sessions to facilitate ride matching and provide accurate arrival estimates to passengers.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">3. How are earnings data handled?</h5>
                  <p className="text-muted">Earnings and transaction data are stored for financial reporting, tax purposes, and to provide you with detailed earning statements.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">4. What vehicle records are maintained?</h5>
                  <p className="text-muted">Vehicle inspection reports and maintenance records are maintained to ensure compliance with safety standards and service quality.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">5. How are driver ratings used?</h5>
                  <p className="text-muted">Driver ratings and passenger feedback are collected to maintain service quality and help improve the overall driving experience.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">6. How is background check information handled?</h5>
                  <p className="text-muted">Background check information is handled with strict confidentiality and is only accessible to authorized personnel for verification purposes.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">7. How are bank details secured?</h5>
                  <p className="text-muted">Bank account details for payment processing are encrypted and stored securely using industry-standard security measures.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">8. Can drivers access their stored information?</h5>
                  <p className="text-muted">Drivers can request access to all stored personal information through their driver portal or by contacting our support team.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">9. When is data shared with authorities?</h5>
                  <p className="text-muted">Data sharing with regulatory authorities occurs only when legally required or in response to valid legal requests.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">10. How are data breaches handled?</h5>
                  <p className="text-muted">Drivers are promptly notified of any data breaches that may affect their personal information, along with steps being taken to address the issue.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;